const constants = Object.freeze({
    dateFormat: 'dd.MM.yyyy',
    timeFormat: 'HH.mm',
    airbnbPickerDateFormat: 'yyyy-MM-dd',
    media: {
        imageModel: 'ImageFileModel',
        vimeoModel: 'VimeoMediaModel',
    },
});

export default constants;
